import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';

import { ADDRESS_SERVICE_PROVIDER_IMPL } from './services/address/address.servce.impl';
import { AddCardDialogComponent } from './components/forms/cards-form/dialogs/add-card-dialog/add-card-dialog.component';
import { AddEditConnectorDialogFormComponent } from './components/forms/connector-form/add-edit-connector-dialog-form/add-edit-connector-dialog-form.component';
import { AddressCardInputComponent } from './components/address-card-input/address-card-input.component';
import { AddressFormComponent } from './components/forms/address-form/address-form.component';
import { AddressSearchDialogComponent } from './components/dialogs/address-search-dialog/address-search-dialog.component';
import { AppButtonComponent } from './components/app-button/app-button.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from './utils/interceptor/auth.interceptor';
import { BlankComponent } from './views/blank/blank.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CALENDAR_SERVICE_PROVIDER } from './services/calendar/calendar.service.impl';
import { CalendarFormComponent } from './components/forms/calendar-form/calendar-form.component';
import { CalendarsComponent } from './views/calendars/calendars.component';
import { CardSubtypeComponent } from './components/forms/cards-form/card-subtype/card-subtype.component';
import { CardsComponent } from './views/cards/cards.component';
import { CardsFormComponent } from './components/forms/cards-form/cards-form.component';
import { ConfigurationComponent } from './views/configuration/configuration.component';
import { ConfigurationFixerComponent } from './views/configuration-fixer/configuration-fixer.component';
import { ConfirmDeleteDialogComponent } from './components/dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { ConnectorFormComponent } from './components/forms/connector-form/connector-form.component';
import { ConnectorsComponent } from './views/connectors/connectors.component';
import { CtaFormComponent } from './components/forms/configuration-form/cta-form/cta-form.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { DiscrepanciesComponent } from './views/discrepancies/discrepancies.component';
import { DragAndDropDirective } from './utils/directives/drag-and-drop/drag-and-drop.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EffectsModule } from '@ngrx/effects';
import { FEATURES_SERVICE_PROVIDER_IMPL } from './services/features/features.service.impl';
import { FeaturesComponent } from './views/features/features.component';
import { FeaturesFormComponent } from './components/forms/features-form/features-form.component';
import { FooterComponent } from './pages/main/footer/footer.component';
import { GithubComponent } from './views/github/github.component';
import { GlobalEffects } from './store/global/global.effects';
import { HeaderComponent } from './pages/main/header/header.component';
import { HeadersInterceptor } from './utils/interceptor/headers.interceptor';
import { LoggerComponent } from './views/logger/logger.component';
import { LoggerDateComponent } from './views/logger/components/logger-date/logger-date.component';
import { LoggerTypeComponent } from './views/logger/components/logger-type/logger-type.component';
import { LoginComponent } from './pages/login/login.component';
import { MESSAGE_SERVICE_PROVIDER } from './services/message/message.service.impl';
import { MainComponent } from './pages/main/main.component';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MenuSidebarComponent } from './pages/main/menu-sidebar/menu-sidebar.component';
import { MenusComponent } from './views/menus/menus.component';
import { MessageDetailDialogComponent } from './components/forms/messages-form/message-detail-dialog/message-detail-dialog.component';
import { MessagesComponent } from './views/messages/messages.component';
import { MessagesDropdownMenuComponent } from './pages/main/header/messages-dropdown-menu/messages-dropdown-menu.component';
import { MessagesFormComponent } from './components/forms/messages-form/messages-form.component';
import { NewsRssFeedsFormComponent } from './components/forms/rss-feeds-form/news-rss-feeds-form/news-rss-feeds-form.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NoticesRssFeedsFormComponent } from './components/forms/rss-feeds-form/notices-rss-feeds-form/notices-rss-feeds-form.component';
import { NotificationsDropdownMenuComponent } from './pages/main/header/notifications-dropdown-menu/notifications-dropdown-menu.component';
import { ONBOARDING_SERVICE } from './services/onboarding/onboarding.service.impl';
import { ORGANISATION_SERVICE } from './services/organisation/organisation.service.impl';
import { OnboardingCreateDialogComponent } from './views/onboardings/onboarding-create-dialog/onboarding-create-dialog.component';
import { OnboardingEditComponent } from './views/onboarding-edit/onboarding-edit.component';
import { OnboardingFormComponent } from './components/forms/onboarding-form/onboarding-form.component';
import { OnboardingsComponent } from './views/onboardings/onboardings.component';
import { OrganisationFormComponent } from './components/forms/organisation-form/organisation-form.component';
import { OrganisationUpdateComponent } from './views/organisation-update/organisation-update.component';
import { OrganisationsComponent } from './views/organisations/organisations.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PlatformFormComponent } from './components/forms/configuration-form/platform-form/platform-form.component';
import { ProfileComponent } from './views/profile/profile.component';
import { QuillModule } from 'ngx-quill';
import { RegisterComponent } from './pages/register/register.component';
import { RequiredCardComponent } from './components/forms/cards-form/required-card/required-card.component';
import { RssFeedsComponent } from './views/rss-feeds/rss-feeds.component';
import { RssProviderDialogComponent } from './components/forms/rss-feeds-form/rss-provider-dialog/rss-provider-dialog.component';
import { RssProviderFormComponent } from './components/forms/rss-feeds-form/rss-provider-form/rss-provider-form.component';
import { RssValidatorComponent } from './views/rss-validator/rss-validator.component';
import { RssValidatorFormComponent } from './components/forms/rss-validator-form/rss-validator-form.component';
import { RssValidatorFormErrorsComponent } from './components/forms/rss-validator-form/form-errors/rss-validator-form-errors.component';
import { StatusComponent } from './views/status/status.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { USER_IMPORT_SERVICE_PROVIDER } from './services/user-import/user-import.service.impl';
import { UserImportComponent } from './views/user-import/user-import.component';
import { UserImportFormComponent } from './components/forms/user-import-form/user-import-form.component';
import { VALIDATOR_SERVICE } from './services/validator/validator.service.impl';
import { environment } from 'src/environments/environment';
import localeEn from '@angular/common/locales/en';
import { reducers } from './store';
import { registerLocaleData } from '@angular/common';
import { NoticesComponent } from './views/notices/notices.component';
import { NOTICES_SERVICE_IMPL } from './services/notice/notices.service.impl';
import { ReportsFormComponent } from './components/forms/configuration-form/reports-form/reports-form.component';
import { REPORTS_SERVICE_IMPL } from './services/report/reports.service.impl';
import { ReimbursementsFormComponent } from './components/forms/configuration-form/reimbursements-form/reimbursements-form.component';
import { REIMBURSEMENTS_SERVICE_IMPL } from './services/reimbursements/reimbursements.service.impl';
import { VendorFormComponent } from './views/vendor-form/vendor-form.component';
import { VendorListComponent } from './views/vendor-list/vendor-list.component';
import { CollectsAiAnalytics } from './views/analytics/collects-ai/analytics.component';
import { ANALYTICS_SERVICE_PROVIDER } from './services/analytics/collects-ai/analytics.service.impl';

import { ChartsModule } from 'ng2-charts';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesDropdownMenuComponent,
        NotificationsDropdownMenuComponent,
        AppButtonComponent,
        ConfigurationComponent,
        StatusComponent,
        ConfigurationFixerComponent,
        LoggerComponent,
        LoggerDateComponent,
        LoggerTypeComponent,
        OrganisationsComponent,
        OnboardingCreateDialogComponent,
        OnboardingEditComponent,
        OnboardingsComponent,
        OnboardingFormComponent,
        GithubComponent,
        MenusComponent,
        CardsComponent,
        CardsFormComponent,
        AddCardDialogComponent,
        CardSubtypeComponent,
        RequiredCardComponent,
        ConnectorsComponent,
        ConnectorFormComponent,
        AddEditConnectorDialogFormComponent,
        ConfirmDeleteDialogComponent,
        RssValidatorComponent,
        RssFeedsComponent,
        BreadcrumbComponent,
        NewsRssFeedsFormComponent,
        PageHeaderComponent,
        NoticesRssFeedsFormComponent,
        RssValidatorFormComponent,
        RssProviderFormComponent,
        RssProviderDialogComponent,
        RssValidatorFormErrorsComponent,
        MessagesComponent,
        MessagesFormComponent,
        MessageDetailDialogComponent,
        CalendarsComponent,
        CalendarFormComponent,
        UserImportComponent,
        UserImportFormComponent,
        DragAndDropDirective,
        FeaturesComponent,
        FeaturesFormComponent,
        DiscrepanciesComponent,
        ToolbarComponent,
        ConfirmDialogComponent,
        OrganisationUpdateComponent,
        OrganisationFormComponent,
        PlatformFormComponent,
        AddressFormComponent,
        AddressSearchDialogComponent,
        AddressCardInputComponent,
        CtaFormComponent,
        NoticesComponent,
        ReportsFormComponent,
        ReimbursementsFormComponent,
        VendorFormComponent,
        VendorListComponent,
        CollectsAiAnalytics,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        NgbModule,
        NgxJsonViewerModule,
        MatSelectModule,
        MatButtonModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        FormsModule,
        MatIconModule,
        StoreModule.forRoot(reducers),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
        EffectsModule.forRoot([GlobalEffects]),
        MatDatepickerModule,
        MatNativeDateModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatGridListModule,
        DragDropModule,
        MatListModule,
        MatRadioModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatTabsModule,
        QuillModule,
        MatProgressBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        ChartsModule,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-CA' },
        ORGANISATION_SERVICE,
        { provide: 'Window', useValue: window },
        ONBOARDING_SERVICE,
        VALIDATOR_SERVICE,
        MESSAGE_SERVICE_PROVIDER,
        CALENDAR_SERVICE_PROVIDER,
        USER_IMPORT_SERVICE_PROVIDER,
        FEATURES_SERVICE_PROVIDER_IMPL,
        ADDRESS_SERVICE_PROVIDER_IMPL,
        NOTICES_SERVICE_IMPL,
        REPORTS_SERVICE_IMPL,
        REIMBURSEMENTS_SERVICE_IMPL,
        ANALYTICS_SERVICE_PROVIDER,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
